export const getPublishedData = (data) => {
  const date = new Date()
  const finalData = data.filter(({ node }) => {
    if (node.field_affichage_planifie && node.field_date_de_publication) {
      if (node.field_date_de_depublication) {
        return (
          new Date(node.field_date_de_publication) <= date &&
          new Date(node.field_date_de_depublication) >= date
        )
      }
      return new Date(node.field_date_de_publication) <= date
    }
    return true
  })
  return finalData
}
